import React, { useState } from "react";
import rc1 from "../assets/img/rc1.png";
import RepairAccountsData from "../components/card/RepairAccountsData";
import RepairInquiriesData from "../components/card/RepairInquiriesData";
import CreditReviewSend from "../components/Tab/CreditReviewSend";

function RepairCredit() {
  const [activeStep, setActiveStep] = useState(1);
  const [selectedCards, setSelectedCards] = useState(0);

  const handleNext = () => {
    if (activeStep < 3) {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    }
  };

  // Handle card selection or deselection
  const handleCardSelection = (isChecked) => {
    if (isChecked) {
      setSelectedCards((prev) => prev + 1);
    } else {
      setSelectedCards((prev) => Math.max(prev - 1, 0));
    }
  };

  return (
    <>
      <section className="repair_credit page_overflow">
        <div className="container">
          <div className="step-container">
            <div className="step-content">
              {activeStep === 1 && (
                <>
                  <div className="section_title mb-2">
                    <h1>Start your Credit Repair</h1>
                  </div>
                  <div className="card p-0">
                    <div className="card_img">
                      <img src={rc1} alt="" />
                    </div>
                    <div className="card-body mt-3">
                      <h3>
                        Begin Your Credit Repair using Artificial Intelligence
                      </h3>
                      <p className="mt-3">
                        Permanently Increase your Credit Score by removing
                        errors, inaccuracies, FCRA violations, negative
                        accounts, and more with just one-click.
                      </p>
                      <div className="btn_group mt-2">
                        <button
                          className="btn next-button"
                          onClick={handleNext}
                        >
                          Start the Repair
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {activeStep === 2 && (
                <div className="accounts">
                  <div className="section_title mb-2">
                    <h1>Accounts</h1>
                  </div>
                  <RepairAccountsData onCardSelect={handleCardSelection} />
                  <div className="">
                    <div className="mt-3">
                      <h1>Inquiries</h1>
                      <p className="text-red mt-2">
                        **DO NOT DISPUTE OPEN ACCOUNTS**
                      </p>
                    </div>
                    <RepairInquiriesData onCardSelect={handleCardSelection} />
                  </div>
                  <div className="btn_group">
                    {selectedCards > 0 && (
                      <button className="btn btn_s">
                        Selected Items: {selectedCards}
                      </button>
                    )}
                    <button
                      className="btn btn_s back-button"
                      onClick={handleBack}
                    >
                      Back
                    </button>
                    <button className="btn next-button" onClick={handleNext}>
                      Next
                    </button>
                  </div>
                </div>
              )}
              {activeStep === 3 && (
                <div className="credit_review_send">
                  <div className="section_title mb-2">
                    <h1>Review & Send</h1>
                  </div>
                  <CreditReviewSend />
                </div>
              )}
            </div>
            <div className="steps">
              <button
                className={`step ${activeStep === 1 ? "active" : ""}`}
                disabled={activeStep !== 1}
              >
                1
              </button>
              <button
                className={`step ${activeStep === 2 ? "active" : ""}`}
                disabled={activeStep < 2}
              >
                2
              </button>
              <button
                className={`step ${activeStep === 3 ? "active" : ""}`}
                disabled={activeStep < 3}
              >
                3
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RepairCredit;
